module.exports = __webpack_public_path__ + "img/quinoa.be5030ca.webp";